import { SvgIcon, SvgIconProps } from "@mui/material";

export const TemplateTestIconFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "40px", height: props.height ?? "41px" }}
    >
      <svg
        {...props}
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_13062_29891)">
          <path
            d="M34.104 0.487305H0.494141V36.3109H34.104V0.487305Z"
            fill={props.fill ?? "#2962FF"}
            stroke="white"
            strokeMiterlimit="10"
          />
          <path
            d="M39.506 6.72754H5.92578V40.4645H39.506V6.72754Z"
            fill={props.fill ?? "#2962FF"}
            stroke="white"
            strokeMiterlimit="10"
          />
          <path
            d="M10.3711 35.2386L20.2476 19.6377L26.6674 29.8758L30.1242 25.9756L35.0625 35.2386H10.3711Z"
            fill="white"
          />
          <path
            d="M27.9711 15.864C29.433 15.864 30.618 14.6941 30.618 13.2508C30.618 11.8076 29.433 10.6377 27.9711 10.6377C26.5093 10.6377 25.3242 11.8076 25.3242 13.2508C25.3242 14.6941 26.5093 15.864 27.9711 15.864Z"
            fill="white"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
